import { Typography, cn, Button, IconChevronRight, NotificationBadge } from '@up-riac/bespoke-ui';
import React from 'react';

export const HeaderMobileMenuNavItem = ({
  to, noArrow, description, accent, id, label, onPress,
  notificationCount,
}: {to?: string, noArrow?: boolean, description?: React.ReactNode, accent?: boolean, id: string, label: string, onPress?: () => void, notificationCount?: number}) => {
  return (
    <Button
      unstyled
      id={id}
      to={to}
      className={cn(
        'bg-surface-dark py-4 pr-[7px] pl-5 flex flex-row gap-4 w-full justify-between items-center text-text-contrast-light transition-150 ease-in-out transition-all',
        'active:text-accent-active hover:text-accent-hover active:bg-[#242424] hover:bg-[#1F1F1F]',
        'disabled:active:text-text-contrastl-light disabled:hover:text-text-contrast-light disabled:active:bg-surface-dark disabled:hover:bg-surface-dark disabled:cursor-default',
        accent && 'text-accent',
      )}
      isDisabled={!to && !onPress}
      onPress={onPress}
    >
      <div className='flex flex-col gap-1'>
        <Typography weight='medium' heading size='xs'>{label}</Typography>
        {description && <Typography weight='regular' size='sm' className='text-neutral-600 italic'>{description}</Typography>}
      </div>
      <div className='flex flex-row items-center gap-4'>
        {(notificationCount && notificationCount > 0)
          && <div>
            <NotificationBadge count={notificationCount} />
          </div>
        || ''}
        <IconChevronRight className={cn('size-8', noArrow && 'opacity-0')} />
      </div>
    </Button>
  );
};
